import { Box, CircularProgress, Typography } from "@mui/material";
import globalClasses from "../../commoncomponents/css/Global.module.css";

const PaymentInprogress = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Typography variant="h6" className={globalClasses.typography}>
        Your payment is in progress!
      </Typography>

      <Box
        className={globalClasses.loader}
        sx={{ marginTop: { xs: "20px", md: "150px" } }}
      >
        <CircularProgress color="primary" disableShrink />
      </Box>
    </Box>
  );
};

export default PaymentInprogress;
